import gql from 'graphql-tag';

export const GET_DELIVERY_LIST = gql`
query(
    $toDay: String
    $endDay: String
){
    getDeliveryList(
        toDay: $toDay
        endDay: $endDay
    ){
        DeliveryList{
            delivery_id
            delivery_date
            delivery_contents
            valid_flag
        }
    }
}
`;

export const REGISTER_DELIVERY = gql`
mutation(
    $delivery_id: Int
    $delivery_date: String
    $delivery_contents: String
){
    RegisterDelivery(
        delivery_id: $delivery_id
        delivery_date: $delivery_date
        delivery_contents: $delivery_contents
    ){
        result
    }
}
`;

export const UPDATE_DELIVERY = gql`
mutation(
    $delivery_id: Int
    $delivery_date: String
    $delivery_contents: String
){
    UpdateDelivery(
        delivery_id: $delivery_id
        delivery_date: $delivery_date
        delivery_contents: $delivery_contents
    ){
        result
    }
}
`;

export const DELETE_DELIVERY = gql`
mutation(
    $delivery_id: Int
    $delivery_date: String
    ){
    DeleteDelivery(
        delivery_id: $delivery_id
        delivery_date: $delivery_date
    ){
        result
    }
}
`;
